import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareAccessRoute: InvariantJiraRoute = {
	name: 'project-settings-software-access',
	path: '/jira/software/projects/:projectKey/settings/access',
	exact: true,
};
